import {useContext} from 'react';
import {IsMockedContext} from 'store/IsMocked';

function useIsMocked() {
    return useContext(IsMockedContext);
}

export default useIsMocked;
